import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../components/Pagination";
import SearchBar from "../../../components/SearchBar";
import ExportToExcel from "../../../components/ExportToExcel";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_FilterForm from "../../../components/Dynamic_FilterForm";
import { FaSpinner } from "react-icons/fa";

const ResourceReport = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Resource Report"));
  }, []);

  const [resource, setResource] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emp, setEmp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(150);

  const filters = {
    Employee: 0,
  };
  const [filter, setFilter] = useState(filters);

  useEffect(() => {
    fetchResourceReport();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);



  const [apiStatus, setApiStatus] = useState(undefined)
  const fetchResourceReport = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/3?P_EmployeeID=${filter?.Employee}`
      );



      setApiStatus(response?.status)
      if (response?.status === 200) {
        setResource(response?.data?.header);

        const emplist = response?.data?.employee.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        emplist.unshift({ value: 0, label: "Select..." });
        setEmp(emplist);
      }
    } catch (error) {
      console.error("Fetching Data Error", error);
    }
  };


  // pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Compute the current page's data
  const startIndex = (currentPage - 1) * itemsPerPage;
  // Math.min(startIndex + itemsPerPage, filteredData.length)
  const endIndex = Math.min(startIndex + itemsPerPage, resource.length);
  const paginatedData = resource.slice(startIndex, endIndex);
  const testData = paginatedData.reduce((acc, item) => {
    // Check if the client exists, if not create an object for it
    if (!acc[item.ClientName]) {
      acc[item.ClientName] = {};
    }

    // Check if the project exists under that client, if not create an array for it
    if (!acc[item.ClientName][item.ProjectName]) {
      acc[item.ClientName][item.ProjectName] = [];
    }

    // Push the current item into the respective project array
    acc[item.ClientName][item.ProjectName].push(item);

    return acc;
  }, {}); // Initialize accumulator as an empty object

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const filteredData = paginatedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  console.log("filteredData::::", filteredData);


  const [activeClientKey, setActiveClientKey] = useState(null); // To track active client accordion
  const [activeProjectKey, setActiveProjectKey] = useState({}); // To track active project accordion for each client

  const handleClientToggle = (clientKey) => {
    setActiveClientKey(activeClientKey === clientKey ? null : clientKey);
  };

  const handleProjectToggle = (clientIndex, projectKey) => {
    setActiveProjectKey((prev) => ({
      ...prev,
      [clientIndex]: prev[clientIndex] === projectKey ? null : projectKey,
    }));
  };

  const [selectedEmployeeValue, setSelectedEmployeeValue] = useState();

  const formatDataForExcel = (data) => {
    if (!data || data.length === 0) return [];

    // Group data by client first
    const groupedByClient = data.reduce((acc, item) => {
      const clientName = item.ClientName || "Unknown Client";
      if (!acc[clientName]) {
        acc[clientName] = {};
      }

      // Then group by project
      const projectName = item.ProjectName || "Unknown Project";
      if (!acc[clientName][projectName]) {
        acc[clientName][projectName] = [];
      }

      // Add employee data to the project
      acc[clientName][projectName].push(item);

      return acc;
    }, {});

    // Create formatted data array for Excel
    const formattedData = [];

    // Add header row
    formattedData.push({
      EmpID: "Emp. ID",
      EmployeeName: "Employee Name",
      StartDate: "Start Date",
      EndDate: "End Date",
      ExtendedEndDate: "Extended End Date",
      ActualEndDate: "Actual End Date",
      BillingRate: "Billing Rate",
      Incentive: "Incentive",
    });

    // Process each client
    Object.entries(groupedByClient).forEach(([clientName, projects]) => {
      // Add client row
      formattedData.push({
        EmpID: "",
        EmployeeName: `Client: ${clientName}`,
        StartDate: "",
        EndDate: "",
        ExtendedEndDate: "",
        ActualEndDate: "",
        BillingRate: "",
        Incentive: "",
      });

      // Process each project under this client
      Object.entries(projects).forEach(([projectName, employees]) => {
        // Add project row
        formattedData.push({
          EmpID: "",
          EmployeeName: `Project: ${projectName}`,
          StartDate: "",
          EndDate: "",
          ExtendedEndDate: "",
          ActualEndDate: "",
          BillingRate: "",
          Incentive: "",
        });

        // Add each employee row under this project
        employees.forEach((employee) => {
          formattedData.push({
            EmpID: employee.EmpID || "",
            EmployeeName: employee.EmployeeName || "",
            StartDate: employee.StartDate || "",
            EndDate: employee.EndDate || "",
            ExtendedEndDate: employee.ExtendedEndDate || "",
            ActualEndDate: employee.ActualEndDate || "",
            BillingRate: employee.BillingRate || "",
            Incentive: employee.Incentive || "NO",
          });
        });
      });
    });

    return formattedData;
  };




  const formDatas = [
    {
      name: "Employee",
      type: "Select",
      options: [...emp],
    },
  ];
  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/3?P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }`
      );
      setApiStatus(response?.status)
      if (response?.status === 200) {
        setResource(response?.data?.header);
        const emplist = response?.data?.employee.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        emplist.unshift({ value: 0, label: "Select..." });
        setEmp(emplist);
      }
    } catch (error) {
      console.error("Fetching Data Error", error);
    }
  };

  const handleReset = () => {
    setFilterData([]);
    fetchResourceReport();
  };



  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
   const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  
    // Calculate total pages based on the current `selectedRecordsPerPage`
    const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);
  
    // Data to display for the current page
    const currentPageData = filteredData.slice(
      (currentPage - 1) * selectedRecordsPerPage,
      currentPage * selectedRecordsPerPage
    );
    const handleRecordsPerPage = (e) => {
      const newRecordsPerPage = Number(e.target.value);
  
      // Calculate the new starting record index based on the current page
      const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
      const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  
      // Update state 
      setSelectedRecordsPerPage(newRecordsPerPage);
      setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
      setItemsPerPage(newRecordsPerPage);
    };
  
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">


          <div className="table-responsive">
            <div className="d-flex justify-content-between">
              <div className="d-flex ">
                <div className="d-flex">
                  <div className="me-1">
                    <SearchBar
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                </div>
                <div className="dropdown">
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                  >
                    <button
                      className="dropdown-toggle"
                      type="button"
                      id="excel-btn"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-funnel-fill"></i>
                    </button>
                  </OverlayTrigger>

                  <div>
                    <Dynamic_FilterForm
                      formData={formDatas || []}
                      handleChange={handleChange}
                      handleReset={handleReset}
                      handleGetData={handleGetData}
                      filterFormData={filterFormData}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div className="me-1">
                  <ExportToExcel
                    data={formatDataForExcel(resource)}
                    filename="RevenueByResource.csv"
                  />
                </div>
              </div>
            </div>

            <div style={{ overflowX: "auto", width: "100%" }}>
              <Table
                bordered
                // striped
                // hover
                style={{ tableLayout: "fixed", minWidth: "2000px" }}
              >


                <thead id="thcolor" className="text-center">
                  <tr>
                    <th style={{ width: "40px" }}>EMP ID</th>
                    <th style={{ width: "90px" }}>Emp. Name</th>
                    <th style={{ width: "90px" }}>Start Date</th>
                    <th style={{ width: "90px" }}>End Date</th>
                    <th style={{ width: "90px" }}>Extended End Date</th>
                    <th style={{ width: "90px" }}>Actual End Date</th>
                    <th style={{ width: "90px" }}>Billing Rate</th>
                    <th style={{ width: "60px" }}>Incentive Applicable</th>
                  </tr>
                </thead>
                {apiStatus === 200 && filteredData.length > 0 ?<tbody>
                  {Object.entries(
                    filteredData.reduce((acc, item) => {
                      if (!acc[item.ClientName]) {
                        acc[item.ClientName] = {};
                      }
                      if (!acc[item.ClientName][item.ProjectName]) {
                        acc[item.ClientName][item.ProjectName] = [];
                      }
                      acc[item.ClientName][item.ProjectName].push(item);
                      return acc;
                    }, {})
                  ).map(([clientName, projects], clientIndex) => (
                    <tr key={clientIndex}>
                      <td
                        colSpan={8}
                        className="px-0"
                        style={{ padding: "0px !important" }}
                      >
                        <Accordion
                          activeKey={activeClientKey}
                          onSelect={() =>
                            handleClientToggle(clientIndex.toString())
                          }
                        >
                          <Accordion.Item eventKey={clientIndex.toString()}>
                            <Accordion.Header className="AccordioninvoiceClient_header">
                              <span className="me-2 accordion_icon">
                                <FontAwesomeIcon
                                  icon={
                                    activeClientKey === clientIndex.toString()
                                      ? faMinus
                                      : faPlus
                                  }
                                />
                              </span>
                              <div className="flex-grow-1 text-dark fw-bold">
                                {clientName}
                              </div>
                            </Accordion.Header>
                            <Accordion.Body className="no-padding">
                              <Accordion
                                activeKey={activeProjectKey[clientIndex] || null} // Ensure null as fallback if no active project
                                onSelect={(projectKey) =>
                                  handleProjectToggle(clientIndex, projectKey)
                                }
                              >
                                {Object.entries(projects).map(
                                  ([projectName, items], projectIndex) => (
                                    <Accordion.Item
                                      eventKey={projectIndex.toString()}
                                      key={projectIndex}
                                    >
                                      <Accordion.Header>
                                        <div className="flex-grow-1 px-8 text-dark">
                                          {projectName}
                                        </div>
                                        <span className="me-2 accordion_icon">
                                          <FontAwesomeIcon
                                            icon={
                                              activeProjectKey[clientIndex] ===
                                                projectIndex.toString()
                                                ? faMinus
                                                : faPlus
                                            }
                                          />
                                        </span>
                                      </Accordion.Header>
                                      <Accordion.Body className="no-padding">
                                        <Table bordered>
                                          <tbody>
                                            {items.map((data, subIndex) => (
                                              <tr
                                                key={subIndex}
                                                className="border"
                                              >
                                                <td
                                                  style={{
                                                    width: "40px",
                                                    // overflow: "hidden",
                                                    // textOverflow: "ellipsis",
                                                    // whiteSpace: "nowrap",
                                                  }}
                                                  className="text-center"
                                                >
                                                  {data.Code}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {data.EmployeeName}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-center"
                                                >
                                                  {(data.StartDate &&
                                                    moment(data.StartDate).format(
                                                      "DD-MMM-YYYY"
                                                    )) ||
                                                    "-"}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-center"
                                                >
                                                  {(data.EndDate &&
                                                    moment(data.EndDate).format(
                                                      "DD-MMM-YYYY"
                                                    )) ||
                                                    "-"}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-center"
                                                >
                                                  {data.ExtendedEndDate
                                                    ? moment(
                                                      data.ExtendedEndDate
                                                    ).format("DD-MMM-YYYY")
                                                    : "-"}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-center"
                                                >
                                                  {data.ActualEndDate
                                                    ? moment(
                                                      data.ActualEndDate
                                                    ).format("DD-MMM-YYYY")
                                                    : "-"}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "90px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-end"
                                                >
                                                  {data.BillingRate}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "60px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  className="text-end"
                                                >
                                                  {data.IncentiveApplicable}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  )
                                )}
                              </Accordion>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </td>
                    </tr>
                  ))}
                </tbody>: apiStatus === undefined && filteredData.length === 0 ?
                <tbody>
                  <tr>
                    <td colSpan={8}>
                      <div  className="d-flex justify-content-center align-items-center">
                        <p>
                          <FaSpinner className= "spinner"/>
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>:apiStatus === 200 && filteredData.length === 0?
                <tbody>
                  <tr>
                    <td colSpan={8}>
                      <div  className="d-flex justify-content-center align-items-center">
                        <p>
                          No Data Found
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>:null}
              </Table></div>
            <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourceReport;
